import { Dayjs } from "dayjs";
import { ManualFuelVolume } from "../manual-fuel-volume/manual-fuel-volume.entity";

export enum InpputByEnum {
  manual = "Manual",
  PI = "PI",
}

export interface OptionFilterItem {
  key: string;
  filter: (number | string)[];
}

export interface OptionFilterCombustion {
  filter: OptionFilterItem[];
}

export interface FilterCombustion {
  stackId?: number[] | null;
  sourceId?: number[] | null;
  area?: string[] | null;
  fuelName?: number[] | null;
  volumeInputBy?: string[] | null;
  densityInputBy?: string[] | null;
  volumeTagPI?: string[] | null;
  densityTagPI?: string[] | null;
  exceptionDate?: string[] | null;
}

export interface DateRange {
  start: Dayjs;
  end: Dayjs;
}

export interface Emission {
  tvoc: boolean;
  bz: boolean;
  bd: boolean;
  vcm: boolean;
  edc: boolean;
}

export interface ResponseAPI {
  code: number;
  status: string;
  name: string;
  message: string;
  data: {
    combustions: CombustionFuelVolume[];
    total: number;
  };
}

export interface ResponseYearsOfCombustion {
  code: number;
  status: string;
  name: string;
  message: string;
  data: [];
}

export interface dropdownOption {
  key?: string;
  label: string;
  value: string;
}

export interface TagPI {
  tagPI: string;
  unit: string;
}

export interface Volume {
  inputBy: string;
  tagPI: TagPI[];
}

export interface Density {
  inputBy: string;
  tagPI: TagPI;
}

export interface ExceptionDate {
  startDate: string;
  endDate: string;
}

export interface CombustionFuelVolume {
  _id?: string;
  companyId: string;
  stackId: number | string;
  sourceId: number | string;
  area: string;
  fuelName: string;
  fuelType: string;
  volume: Volume;
  density: Density;
  exceptionDate: ExceptionDate[];
  exceptionDateArr: string[];
  year: number | string;
  manualFuelVolume: ManualFuelVolume;
}

export interface MasterSettings {
  _id?: string;
  type: string;
  label: string;
  parentId?: string;
  options: dropdownOption[];
}

export enum InputByEnum {
  MANUAL = "Manual",
  PI = "PI",
}

export enum UnitEnum {
  TON = "Ton",
  KG = "Kg",
  L = "L",
  M3 = "M3",
  KG_L = "Kg/L",
  SG = "SG",
  KG_M3 = "Kg/m3",
  HR = "Hr",
  G = "g",
}

export const Masters: MasterSettings[] = [
  {
    type: "combustion",
    label: "unitVolume",
    options: [
      { key: "fo", value: UnitEnum.L, label: "L" },
      { key: "diesel", value: UnitEnum.L, label: "L" },
      { key: "fg", value: UnitEnum.M3, label: "M3" },
      { key: "ng", value: UnitEnum.M3, label: "M3" },
      { key: "lpg", value: UnitEnum.L, label: "L" },
    ],
  },
  {
    type: "combustion",
    label: "unitDensity",
    options: [
      { key: "fo", value: "Kg/L", label: "Kg/L" },
      { key: "fo", value: "SG", label: "SG" },
      { key: "diesel", value: "Kg/L", label: "Kg/L" },
      { key: "diesel", value: "SG", label: "SG" },
      { key: "fg", value: "Kg/m3", label: "Kg/m3" },
      { key: "ng", value: "Kg/m3", label: "Kg/m3" },
      { key: "lpg", value: "Kg/L", label: "Kg/L" },
      { key: "lpg", value: "SG", label: "SG" },
    ],
  },
];

export const initData = {
  year: "",
  companyId: "",
  stackId: "",
  sourceId: "",
  area: "",
  fuelName: "",
  fuelType: "",
  volume: {
    inputBy: "",
    tagPI: [{ tagPI: "", unit: "" }],
  },
  density: { inputBy: "", tagPI: { tagPI: "", unit: "" } },
  exceptionDate: [],
  exceptionDateArr: [],
  manualFuelVolume: {
    unit: "",
    jan: {
      value: 0,
      reportStatus: "",
    },
    feb: {
      value: 0,
      reportStatus: "",
    },
    mar: {
      value: 0,
      reportStatus: "",
    },
    apr: {
      value: 0,
      reportStatus: "",
    },
    may: {
      value: 0,
      reportStatus: "",
    },
    jun: {
      value: 0,
      reportStatus: "",
    },
    jul: {
      value: 0,
      reportStatus: "",
    },
    aug: {
      value: 0,
      reportStatus: "",
    },
    sep: {
      value: 0,
      reportStatus: "",
    },
    oct: {
      value: 0,
      reportStatus: "",
    },
    nov: {
      value: 0,
      reportStatus: "",
    },
    dec: {
      value: 0,
      reportStatus: "",
    },
  },
};
